import React, { useEffect, useRef } from 'react';
import "./Checkbox.css"
import LocalizedText from "../LocalizedText";

interface CheckboxProps {
	identifier?: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	disabled?: boolean;
	checked: boolean;
	indeterminate?: boolean;
	className?: string;
	label?: string;
    labelKey?: string;
    labelValues?: { [key: string]: any };
	onFocus?: React.FocusEventHandler<HTMLInputElement>;
	onBlur?: React.FocusEventHandler<HTMLInputElement>;
	size?: 'small' | 'default' | 'large';
	labelPosition?: 'left' | 'right';
	children?: React.ReactNode;
}

export function Checkbox(props: CheckboxProps) {
	const cRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (cRef.current && props.indeterminate !== undefined) {
			cRef.current.indeterminate = props.indeterminate;
		}
	}, [cRef, props.indeterminate]);

	return (
		<label className={`${props.className} ${"mdhd-checkbox-field"} ${props.disabled ? "disabled" : ""}`} onClick={(e)=>{e.stopPropagation()}} htmlFor={props.identifier}>
			{props.label && (props.labelPosition == 'left') &&
				<span>{props.label}</span>
			}
      {!props.label && props.labelKey && (props.labelPosition == 'left') &&
        <LocalizedText textKey={props.labelKey} values={props.labelValues} />
      }
			<input className="mdhd-checkbox-input" id={props.identifier} type="checkbox" disabled={props.disabled} checked={props.checked} ref={cRef} onChange={props.onChange} />
			{props.label && (props.labelPosition !== 'left') &&
				<span>{props.label}</span>
			}
      {!props.label && props.labelKey && (props.labelPosition !== 'left') &&
        <LocalizedText textKey={props.labelKey} values={props.labelValues} />
      }
			{props.children}
		</label>
	);
}

export default Checkbox;

